import { createSelector } from '@ngrx/store';

import { productRestrictionsState } from '../root';

export const getProductsWithRestrictions = createSelector(productRestrictionsState, (productRestrictions) => productRestrictions.productsWithRestrictions);
